import { Button } from '@headlessui/react'
import type { Dispatch, SetStateAction } from 'react'
import { cn } from '../../shared/cn'
import { Link } from '../actions/Link'
import { P2 } from '../typography/Paragraph'

type TabsProps = {
  className?: string
} & (
  | {
      tabs: {
        label: string
        href: string
      }[]
      tabParam: string
      activeTab?: never
      setActiveTab?: never
    }
  | {
      tabs: {
        label: string
        icon?: React.ReactNode
        href?: never
      }[]
      tabParam?: never
      activeTab: string
      setActiveTab: Dispatch<SetStateAction<string>>
    }
)

export function Tabs(props: TabsProps) {
  const { tabs, className } = props
  const isUrlMode = 'tabParam' in props && props.tabParam !== undefined
  const tabParam = isUrlMode ? props.tabParam : undefined
  const activeTab = isUrlMode ? undefined : props.activeTab
  const setActiveTab = isUrlMode ? undefined : props.setActiveTab

  return (
    <div className={cn('custom-scrollbar flex touch-pan-x gap-4 overflow-x-auto', className)}>
      {tabs.map((tab: { label: string; icon?: React.ReactNode; href?: string }) => {
        const isActive = isUrlMode ? tab.href && tab.href === tabParam : activeTab === tab.label
        const href = tab.href ? `?tab=${tab.href}` : undefined

        if (href) {
          return (
            <Link
              key={tab.label}
              href={href}
              className={cn(
                'group rounded-lg px-3 py-2 hover:bg-backgroundHoverOverlay',
                isActive && 'bg-backgroundColor'
              )}
            >
              <P2
                className={cn(
                  'text-nowrap text-contentSecondary',
                  'group-hover:text-contentColorPrimary',
                  isActive && 'text-contentColorPrimary'
                )}
              >
                {tab.label}
              </P2>
            </Link>
          )
        }

        return (
          <Button
            key={tab.label}
            className={cn(
              'group rounded-lg px-3 py-2 hover:bg-backgroundHoverOverlay',
              isActive && 'bg-backgroundColor'
            )}
            onClick={() => setActiveTab?.(tab.label)}
          >
            <P2
              className={cn(
                'flex items-center justify-center gap-2 text-nowrap text-contentSecondary',
                'group-hover:text-contentColorPrimary',
                isActive && 'text-contentColorPrimary'
              )}
            >
              {tab.icon}
              {tab.label}
            </P2>
          </Button>
        )
      })}
    </div>
  )
}
